import { getBaseUrl, Microservice } from "@funded-here-interface/common/src/constant/baseUrl";
import { merchantAccountStatusSchema } from "@funded-here-interface/common/src/schemas/merchantAccount";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { parseContract } from "@funded-here-interface/common/src/Utils/parseContract";
import axios from "axios";

import { UserType } from "../types/login.type";

const getMerchantAccountStatus = async ({ token }: UserType) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/merchant-account-status`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return parseContract(merchantAccountStatusSchema, response.data, "getMerchantAccountStatus");
  } catch (e) {
    const message = getApiResponseErrorMsg(e, "getMerchantAccountStatus");
    throw new Error(message);
  }
};

export default getMerchantAccountStatus;
